import { Card, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSButton from "../../Components/Button/WSButton";
import WSDateField from "../../Components/DateField/WSDateField";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../Components/TextBox/WSTextBox";
import config from "../../Config/clientConfig.json";

import dayjs from "dayjs";
import {
  callAPI,
  clearRequest,
  getLocalValue,
  handleApiError,
  IsSmallScreen,
  LoacalVariables,
  Method,
  updateMainHeader
} from "../../commonFunctions/CommonFunctions";
import { HeaderList, IHeaderListActions } from "../../Components/Header/HeaderList";
import WSPhone from "../../Components/Phone/WSPhone";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import clientConfig from '../../Config/clientConfig.json';
export const Orders: React.FC<any> = React.memo((props) => {

  const { id, orderId, estimationId, quatationId, workOrderId } = useParams();
  const params = useParams();
  console.log('params are', params)
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const paymentTermsDefault: any = [
    {
      percentage: 30,
      description: "of total value of work on order confirmation."
    },
    {
      percentage: 60,
      description:
        "of total value of work on delivery of material to site."
    },
    {
      percentage: 10,
      description: "balance after completion of work."
    }
  ]
  const { control, register, handleSubmit, setValue, getValues, watch } = useForm({
    defaultValues: {
      ownerId: localStorage.getItem("UserId"),
      customerName: "",
      phone: "",
      stage: config.stageConfig.staticOptionData[0].value,
      completion: "",
      commencement: "",
      address: "",
      leadId: "",
      date: "",
      termsAndConditions: "",
      //  paymentTerms: "",
      remarks: "",
      approximateArea: "",
      rate: "",
      items: [{ productId: "", quantity: "", unit: "", isIncluded: true, unitPrice: "", total: "", isPolish: "2", }],
      itemsExcluded: [{ productId: "", quantity: "", unit: "", isIncluded: false, unitPrice: "", total: "", }],
      amountReceived: "",
      paymentMethod: "",
      transactionReference: "",
      notes: "",
      workOrderId: "",
      invoiceNumber: "",
      accountCode: ' ',
      paymentTerms: [
        {
          percentage: 30,
          description: "of total value of work on order confirmation."
        },
        {
          percentage: 60,
          description:
            "of total value of work on delivery of material to site."
        },
        {
          percentage: 10,
          description: "balance after completion of work."
        }
      ]
    }
  });
  const { fields: itemFields, append: itemAppend, remove: itemRemove, replace: itemReplace } = useFieldArray({
    name: "items",
    control
  });
  const { fields: itemExcludedFields, append: itemExcludedAppend, remove: itemExcludedRemove, replace: itemExcludedReplace } = useFieldArray({
    name: "itemsExcluded",
    control
  });
  const {
    fields: paymentTerms,
    append: paymentAppend,
    remove: paymentRemove,
    replace: paymentReplace
  } = useFieldArray({
    name: "paymentTerms",
    control
  });
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();

  const [products, setProducts] = useState<any>([]);
  const [lead, setLead] = useState<any>([]);
  const isMobile = IsSmallScreen();

  useEffect(() => {
    updateMainHeader(id ? "Edit" : 'Add');

    breadCrumbsStore.updateBreadCrumbs([
      { "Contacts": "/contacts/list" },
      { [id ? "View" : 'Add']: `/contacts/${id}/workorders` },
      { "Orders": "" },

    ]);
  });
  useEffect(() => {

    if (!orderId && !quatationId) {

      async function loadTerms() {
        try {
          const response: any = await callAPI("Termsandcondition", Method.GET);
          const terms: any = response?.data || [];

          const numberedString: string = terms
            .flatMap((item: any) => JSON.parse(item.conditions))
            .map((text: string) => `• ${text}`) // 🔥 bullet instead of numbering
            .join("\n");
          // ✅ set the value *inside* the function
          setValue("termsAndConditions", numberedString);
        } catch (err) {
          console.error("Failed to load terms", err);
        }
      }
      loadTerms()
    }
  }, [])

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response: any = await callAPI("products", Method.GET);
        if (response) {
          setProducts(response.data);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response: any = await callAPI("leads", Method.GET);
        if (response) {
          setLead(response);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    fetchLeads();
  }, []);


  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response: any = await callAPI(`workorders/${orderId}`, Method.GET);
        console.log('fetching estim in work order', response)
        if (response?.data) {
          const orderData = response.data;
          setValue("ownerId", orderData.ownerId || "");
          setValue("customerName", orderData.customerName || "");
          setValue("address", orderData.address || "");
          setValue("phone", orderData.phone || "");
          setValue("stage", orderData.stage || "Draft");
          setValue("approximateArea", orderData.approximateArea || "");
          setValue("termsAndConditions", orderData.termsAndConditions || "");
          setValue("paymentTerms", orderData.paymentTerms || "");
          setValue("remarks", orderData.remarks || "");
          setValue("leadId", orderData.leadId || "");
          setValue("rate", orderData.rate || "");
          // Format Dates
          setValue("date", dayjs(orderData.date).format("MM-DD-YYYY"));
          setValue(
            "commencement",
            dayjs(orderData.commencement).format("MM-DD-YYYY")
          );
          setValue(
            "completion",
            dayjs(orderData.completion).format("MM-DD-YYYY")
          );
          // Populate Items if available
          if (response.data.quotationItems?.length) {
            const formattedItems = response.data.quotationItems
              .filter((item: any) => item.isIncluded === true)
              .map((item: any) => ({
                productId: item.productId,
                quantity: item.quantity.toString(),
                unitPrice: item.unitPrice.toString(),
                unit: item.unit,
                isIncluded: true,
                isPolish: item.isPolish?.toString(),
              }));

            const formattedItemsExcluded = response.data.quotationItems
              .filter((item: any) => item.isIncluded === false)
              .map((item: any) => ({
                productId: item.productId,
                quantity: item.quantity.toString(),
                unitPrice: item.unitPrice.toString(),
                unit: item.unit,
                isIncluded: false,
              }));
            const formattedPaymentTerms = response.data.paymentTerms
              .map((item: any) => ({
                percentage: item.percentage,
                description: item.description,

              }));
            itemReplace(formattedItems);
            itemExcludedReplace(formattedItemsExcluded || []);
            paymentReplace(formattedPaymentTerms?.length > 0 ? formattedPaymentTerms : paymentTermsDefault)
          }
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };
    async function getPayments() {
      const response: any = await callAPI(`payment-receives/work-order/${orderId}`, Method.GET);
      if (response?.data && response?.data?.length > 0) {
        setValue('paymentMethod', response?.data[0]?.paymentMethod)
        setValue('amountReceived', response?.data[0]?.amountReceived)
        setValue('invoiceNumber', response?.data[0]?.invoiceNumber)
        setValue('transactionReference', response?.data[0]?.transactionReference)
        setValue('notes', response?.data[0]?.notes)
        setDisable(true)
      }
      else {
        setDisable(false)
      }
    }
    if (orderId) { fetchOrder(); getPayments() }
  }, [orderId, setValue, itemReplace]);

  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        const response: any = await callAPI("quotations", Method.GET, {}, quatationId);
        if (response?.data) {
          // Set main form values
          setValue("ownerId", response.data.ownerId);
          setValue("customerName", response.data.customerName);
          setValue("address", response.data.address);
          // setValue("subject", response.data.subject);

          //  setValue("discount", response.data.discount);
          setValue("termsAndConditions", response.data.termsAndConditions);
          setValue("remarks", response.data.remarks);
          setValue("leadId", response.data.leadId);
          // setValue("adjustments", response.data.adjustments);

          // Format dates
          setValue("date", dayjs(response.data.date).format("MM-DD-YYYY"));
          // setValue(
          //   "expiredate",
          //   dayjs(response.data.validTill).format("MM-DD-YYYY")
          // );

          // setSubtotal(response.data.subtotal);
          // setTotal(response.data.grandTotal);

          // Populate items (split included vs excluded like quotation page)
          if (response.data.quotationItems?.length) {
            const formattedItems = response.data.quotationItems
              .filter((item: any) => item.isIncluded === true)
              .map((item: any) => ({
                productId: item.productId,
                quantity: item?.quantity?.toString(),
                unit: item.unit,
                unitPrice: item.unitPrice?.toString(),
                isIncluded: true,
                isPolish: item.isPolish?.toString(),
              }));

            const formattedItemsExcluded = response.data.quotationItems
              .filter((item: any) => item.isIncluded === false)
              .map((item: any) => ({
                productId: item.productId,
                quantity: item.quantity?.toString(),
                unit: item.unit,
                unitPrice: item.unitPrice?.toString(),
                isIncluded: false,
              }));
            const formattedPaymentTerms = response.data.paymentTerms
              .map((item: any) => ({
                percentage: item.percentage,
                description: item.description,

              }));
            itemReplace(formattedItems);
            itemExcludedReplace(formattedItemsExcluded || []);

            paymentReplace(formattedPaymentTerms?.length > 0 ? formattedPaymentTerms : paymentTermsDefault)
            const totalInluded = response?.data.quotationItems
              .filter((item: any) => item.isIncluded)
              .reduce((sum: number, item: any) => sum + Number(item.unitPrice * item?.quantity), 0)
              .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            const advanceAmount: any = (totalInluded * 30) / 100;
            setValue('amountReceived', advanceAmount)
          }
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    if (quatationId) fetchQuotation();
  }, [quatationId, setValue, itemReplace]);
  useEffect(() => {

    const fetchEstimationn = async () => {
      try {
        const response: any = await callAPI("quotations", Method.GET, {}, estimationId);
        console.log('fetching estim in work order', response)
        if (response?.data) {
          // Set main form values
          setValue("ownerId", response.data.ownerId);
          setValue("customerName", response.data.customerName);
          setValue("address", response.data.address);
          // setValue("subject", response.data.subject);

          //  setValue("discount", response.data.discount);
          setValue("termsAndConditions", response.data.termsAndConditions);
          setValue("remarks", response.data.remarks);
          setValue("leadId", response.data.leadId);
          // setValue("adjustments", response.data.adjustments);

          // Format dates
          setValue("date", dayjs(response.data.date).format("MM-DD-YYYY"));
          // setValue(
          //   "expiredate",
          //   dayjs(response.data.validTill).format("MM-DD-YYYY")
          // );

          // setSubtotal(response.data.subtotal);
          // setTotal(response.data.grandTotal);

          // Populate items

          // if (response.data.estimateItems?.length) {
          //   const formattedItems = response.data.estimateItems.map(
          //     (item: any) => ({
          //       productId: item.productId,
          //       quantity: item.quantity.toString(),
          //       unit: item.unit,
          //       unitPrice: item.unitPrice.toString()
          //     })
          //   );
          //
          //   replace(formattedItems); // Updates useFieldArray fields
          // }
          if (response.data.quotationItems?.length) {
            const formattedItems = response.data.quotationItems
              .filter((item: any) => item.isIncluded === true) // ✅ keep only included items
              .map((item: any) => ({
                productId: item.productId,
                quantity: item.quantity.toString(),
                unit: item.unit,
                unitPrice: item.unitPrice.toString(),
                isIncluded: true,
                isPolish: item.isPolish.toString(),
              }));
            const formattedItemsExcluded = response.data.quotationItems
              .filter((item: any) => item.isIncluded === false) // ✅ keep only included items
              .map((item: any) => ({
                productId: item.productId,
                quantity: item.quantity.toString(),
                unit: item.unit,
                unitPrice: item.unitPrice.toString(),
                isIncluded: false,
              }));
            const formattedPaymentTerms = response.data.paymentTerms
              .map((item: any) => ({
                percentage: item.percentage,
                description: item.description,

              }));
            itemReplace(formattedItems); // Updates useFieldArray fields
            itemExcludedReplace(formattedItemsExcluded || []);
            paymentReplace(formattedPaymentTerms?.length > 0 ? formattedPaymentTerms : paymentTermsDefault)
          }
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    if (estimationId) fetchEstimationn();
  }, [workOrderId, estimationId, setValue, itemReplace]);

  const handleData = async (data: any, isPrint = false) => {
    try {
      // const productArray: any[] = [...data?.items, ...data?.itemsExcluded];
      const items = data.items.map((i: any) => ({ ...i, isIncluded: true }));
      const itemsExcluded = data.itemsExcluded.map((i: any) => ({ ...i, isIncluded: false }));
      let productArray: any = []
      if (itemsExcluded[0].productId !== undefined && itemsExcluded[0].productId !== "") {
        productArray = [...items, ...itemsExcluded];
      }
      else {
        productArray = [...items]
      }
      const normalizedProductArray = productArray.map((item: any) => ({
        ...item,
        quantity: item.quantity ? Number(item.quantity) : undefined,
        unitPrice: item.unitPrice ? Number(item.unitPrice) : undefined,
        isPolish: (() => {
          if (item.isPolish === '2' || item.isPolish === 2) return '2';
          if (item.isPolish === '1' || item.isPolish === 1 || item.isPolish === true) return '1';
          return '0';
        })(),
      }));
      const paymentTermsValues = getValues("paymentTerms");
      let request = {
        ownerId: localStorage.getItem("UserId"), // Include ownerId
        customerName: data?.customerName || "",
        address: data?.address || "",
        phone: data?.phone || "",
        stage: data?.stage || "New", // Defaulting to "New"
        rate: data?.rate || "",
        approximateArea: data?.approximateArea,
        date: dayjs(data.date).format("YYYY-MM-DDTHH:mm:ss.SSS"),
        commencement: dayjs(data.commencement).format(
          "YYYY-MM-DDTHH:mm:ss.SSS"
        ),
        completion: dayjs(data.completion).format("YYYY-MM-DDTHH:mm:ss.SSS"),
        termsAndConditions: data?.termsAndConditions || "",
        paymentTerms: paymentTermsValues || "",
        remarks: data?.remarks || "",
        leadId: id || "",
        items: normalizedProductArray || []
      };

      setLoading(true)
      const newRequest = clearRequest(request);

      let response: any;

      if (orderId) {
        response = await callAPI('workorders', Method.PUT, newRequest, orderId);
      } else {
        response = await callAPI('workorders', Method.POST, newRequest);
      }

      if (response?.errors) {
        const mess = handleApiError(response);
        showMessage(mess, 'error');
      } else if (response) {
        showMessage(response?.message, response.success === true ? "success" : "error");

        if (response.success === true) {
          const workOrderId = orderId || response?.workOrderId;
          savePaymentData(data, workOrderId)
          if (!isPrint) {
            navigate(`/contacts/${id}/workorders`);
          } else {
            if (workOrderId) {
              window.open(`/order/print/${workOrderId}`, "_blank");
            }
          }
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
    finally {
      setLoading(false)
    }
  };

  const savePaymentData = async (data: any, odrerId: any) => {
    const request: any = {
      "leadId": id,
      "amountReceived": Number(data?.amountReceived),
      "paymentMethod": data?.paymentMethod,
      "transactionReference": data?.transactionReference,
      "notes": data?.notes,
      workOrderId: odrerId,
      //   invoiceNumber: data?.invoiceNumber,
      accountCode: ' ',

    }
    if (data?.paymentId) {

      const response: any = await callAPI(`payment-receives?UserId=${getLocalValue(LoacalVariables.UserId)}`, Method.PUT, request, data.paymentId);
      return response
    } else {
      const response: any = await callAPI(`payment-receives?UserId=${getLocalValue(LoacalVariables.UserId)}`, Method.POST, request);
      return response
    }
  }
  const handlePercentageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {

    setValue(`paymentTerms.${index}.percentage`, Number(event.target.value));

  };
  const handleProductChange = (index: number, event: any) => {
    const selectedProductId = event.target.value; // Get selected product ID
    const selectedProduct = products.find(
      (p: any) => p.id === selectedProductId
    );
    if (selectedProduct) {
      setValue(`items.${index}.unit`, selectedProduct.unit);
      setValue(`items.${index}.quantity`, "1");
      setValue(`items.${index}.unitPrice`, selectedProduct.unitPrice);
    }

  };

  const handleProductChangeExcluded = (index: number, event: any) => {
    const selectedProductId = event.target.value; // Get selected product ID
    const selectedProduct = products.find(
      (p: any) => p.id === selectedProductId
    );
    if (selectedProduct) {
      setValue(`itemsExcluded.${index}.unit`, selectedProduct.unit);
      setValue(`itemsExcluded.${index}.quantity`, "1");
    }
  };

  const handleQuantityChangeExcluded = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`itemsExcluded.${index}.quantity`, event.target.value);
  };
  const handleUnitPriceChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`items.${index}.unitPrice`, event.target.value);
    setValue(`items.${index}.total`, total.toString()); // Convert to string

    // Recalculate Subtotal
    recalculateSubtotal();
  };
  const handleCancelClick = () => {
    navigate(`/contacts/${id}/workorders`)
  };
  const recalculateSubtotal = () => {
    const updatedItems = getValues("items") || [];
    let newSubtotal = updatedItems.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity) || 1;
      const unitPrice = parseFloat(item.unitPrice) || 0;
      return sum + quantity * unitPrice;
    }, 0);
    const updateditemsExcluded = getValues("itemsExcluded") || [];
    let newitemsExcludedSubtotal = updateditemsExcluded.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity) || 1;
      const unitPrice = parseFloat(item.unitPrice) || 0;
      return sum + quantity * unitPrice;
    }, 0);
    setSubtotal(newSubtotal + newitemsExcludedSubtotal);
    //  calculateTotal(newSubtotal + newitemsExcludedSubtotal);
  };
  const actions: IHeaderListActions[] = [
    {
      type: 'button',
      text: 'Cancel',
      size: 'medium',
      onClick: handleCancelClick,
      variant: 'outlined',
      color: 'primary',
    },
    {
      type: 'button',
      text: 'Save',
      loading: loading,
      size: 'medium',
      onClick: handleSubmit((data) => handleData(data)),
      buttonType: 'submit',
      variant: 'outlined',
      color: 'primary',
    },
    {
      type: 'button',
      text: 'Save And Print',
      loading: loading,
      size: 'medium',
      onClick: handleSubmit((data) => handleData(data, true)),
      buttonType: 'submit',
      variant: 'outlined',
      color: 'primary',
    },
  ];
  // useEffect(() => {
  //   calculateTotal(subtotal);
  // }, [subtotal, watch("discount"), watch("adjustments")]);

  // const calculateTotal = (newSubtotal: number) => {
  //   const discount = parseFloat(watch("discount")) || 0;
  //   const adjustments = parseFloat(watch("adjustments")) || 0;
  //   const newTotal = newSubtotal - discount + adjustments;
  //   setTotal(newTotal);
  // };
  const handleUnitPriceChangeExcluded = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`itemsExcluded.${index}.unitPrice`, event.target.value);
    setValue(`itemsExcluded.${index}.total`, total.toString()); // Convert to string

    // Recalculate Subtotal
    recalculateSubtotal();
  };
  return (
    <Grid p={2}>
      <form onSubmit={handleSubmit((data) => handleData(data))}>
        <HeaderList title={orderId ? "Order > Update Order" : "Order > Create New Order"} type="card" actions={actions} isBackButton url={`/contact/edit/${id}`} />

        <Card
          sx={{ borderRadius: "10px", padding: 3, position: "relative", mt: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontWeight={"bold"}> Order</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Customer Name *"}
                rules={{ required: true }}
                id={"customerName"}
                name={"customerName"}
                control={control}
              />
            </Grid>
            <Grid item xs={10} sm={6}>
              <WSPhone
                label={"Contact Number *"}
                id="phone"
                name="phone"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            {/* <Grid item xs={12} sm={2}>
              <WSIcons.SearchIcon />
            </Grid> */}
            <Grid item xs={10} sm={6}>
              <WSTextField
                label={"Address *"}
                // {...register("address")}
                id="address"
                name="address"
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            {/* <Grid item xs={10} sm={6}>
              <WSTextField
                label={"Rate *"}
                // {...register("rate")}
                id="rate"
                name="rate"
                control={control}
                rules={{ required: true }}
                type={TextType.Currency}
                currency={CurrencyType.Rupee}
              />
            </Grid> */}

            <Grid item xs={10} sm={6}>
              <WSTextField
                label={"Remarks"}
                // {...register("remarks")}
                id="remarks"
                name="remarks"
                control={control}
                rules={{ required: false }}
              />
            </Grid>

            <Grid item xs={10} sm={6}>
              <WSSelectField
                rules={{ required: false }}
                // {...register("stage")}
                id="stage"
                control={control}
                defaultValue={config.stageConfig.staticOptionData[0].value}
                label="Stage"
                name="stage"
                options={config.stageConfig.staticOptionData}
              />
            </Grid>

            <Grid item xs={10} sm={6}>
              <WSDateField
                id="date"
                name="date"
                label="Date *"
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            <Grid item xs={10} sm={6}>
              <WSDateField
                id="commencement"
                name="commencement"
                label="Date of commencement *"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={10} sm={6}>
              <WSDateField
                id="completion"
                name="completion"
                label="Date of completion "
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <WSSelectField
                id="leadId"
                label={"Select Lead"}
                name="leadId"
                control={control}
                rules={{ required: "please select a lead" }}
                options={lead.map((value: any) => ({
                  label: value.firstName,
                  value: value.id
                }))}
              />
            </Grid> */}

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="area"
                name="approximateArea"
                label={"Approximate area *"}
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            {/* <Grid item xs={10} sm={6}>
              <WSTextField
                label={"Period of Completion Work"}
                id={"period"}
                name={"period"}
                control={control}
                rules={{ required: false }}
              />
            </Grid> */}

            <Grid item xs={12} mt={2}>
              <Divider />
            </Grid>

            {/* Section Title */}
            <Grid item xs={12}>
              <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>Items</Typography>
            </Grid>

            {/* Dynamic Item Fields */}
            {itemFields.map((row, index) => (
              <Grid
                container
                spacing={2}
                key={row.id}
                alignItems="center"
                mt={1}
                ml={1}
              >
                <Grid item xs={12} sm={2}>
                  <WSSelectField isMobile={isMobile}
                    label="Select a Product"
                    rules={{ required: true }}
                    {...register(`items.${index}.productId`)}
                    id={`selectProduct-${index}`}
                    control={control}
                    options={products.map((product: any) => ({
                      label: product.name,
                      value: product.id
                    }))}
                    inlineSearch
                    onChange={(event) => handleProductChange(index, event)}
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Unit"
                    {...register(`items.${index}.unit`)}
                    id={`unit-${index}`}
                    control={control}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Unit Price"
                    {...register(`items.${index}.unitPrice`, {
                      onChange: (event) => handleUnitPriceChange(index, event)
                    })}
                    id={`unitPrice-${index}`}
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    id={`quantity-${index}`}
                    label="Quantity"
                    {...register(`items.${index}.quantity`)}
                    control={control}
                    type={TextType.Number}
                  />
                </Grid>
                <Grid item xs={2}>
                  <WSSelectField
                    label="Polish"
                    rules={{ required: true }}
                    {...register(`items.${index}.isPolish`)}
                    id={`isPolish-${index}`}
                    control={control}
                    options={config.ploishConfig.staticOptionData}
                    onChange={(event) => handleProductChange(index, event)}
                  />
                </Grid>
                <Grid item xs={1} sm={1}>
                  <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                    ₹
                    {Number(watch(`items.${index}.unitPrice`) || 0) *
                      Number(watch(`items.${index}.quantity`) || 0)}
                  </Typography>
                </Grid>

                <WSHiddenField name={`items.${index}.isIncluded`} control={control} defaultValue={true} />
                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => itemRemove(index)}
                    sx={{ color: "red", cursor: 'pointer' }}
                  />
                </Grid>
              </Grid>
            ))}

            {/* Add Item Button */}
            <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addButton"
                label="+ ADD"
                size="small"
                sx={{ fontSize: '0.875rem' }}
                onClick={() =>
                  itemAppend({
                    productId: "",
                    quantity: "",
                    unit: "",
                    isIncluded: true,
                    unitPrice: "",
                    total: "",
                    isPolish: "2"
                  })
                }
              />
            </Grid>

            {/* <Grid item xs={12}>
              <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>Items Excluded</Typography>
            </Grid> */}

            {/* Dynamic Item Fields */}
            {/* {itemExcludedFields.map((row, index) => (
              <Grid
                container
                spacing={2}
                key={row.id}
                alignItems="center"
                mt={1}
                ml={1}
              >
                <Grid item xs={12} sm={2}>
                  <WSSelectField isMobile={isMobile}
                    label="Select a Product"
                    rules={{ required: true }}
                    {...register(`itemsExcluded.${index}.productId`)}
                    id={`itemsExcluded-${index}`}
                    control={control}
                    options={products.map((product: any) => ({
                      label: product.name,
                      value: product.id
                    }))}
                    onChange={(event) => handleProductChangeExcluded(index, event)}
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Unit"
                    {...register(`itemsExcluded.${index}.unit`)}
                    id={`itemsExcluded-unit-${index}`}
                    control={control}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Unit Price"
                    {...register(`itemsExcluded.${index}.unitPrice`, {
                      onChange: (event) => handleUnitPriceChangeExcluded(index, event)
                    })}
                    id={`itemsExcluded-unitPrice-${index}`}
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    id={`itemsExcluded-quantity-${index}`}
                    label="Quantity"
                    {...register(`itemsExcluded.${index}.quantity`, {
                      onChange: (event) => handleQuantityChangeExcluded(index, event)
                    })}
                    control={control}
                    type={TextType.Number}
                  />
                </Grid>
                <Grid item xs={1} sm={1}>
                  <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                    ₹
                    {Number(watch(`itemsExcluded.${index}.unitPrice`) || 0) *
                      Number(watch(`itemsExcluded.${index}.quantity`) || 0)}
                  </Typography>
                </Grid>

                <WSHiddenField name={`itemsExcluded.${index}.isIncluded`} control={control} defaultValue={false} />
                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => itemExcludedRemove(index)}
                    sx={{ color: "red", cursor: 'pointer' }}
                  />
                </Grid>
              </Grid>
            ))} */}

            {/* Add Item Button */}
            {/* <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addButton"
                label="+ ADD"
                size="small"
                sx={{ fontSize: '0.875rem' }}
                onClick={() =>
                  itemExcludedAppend({
                    productId: "",
                    quantity: "",
                    unit: "",
                    isIncluded: false,
                    unitPrice: "",
                    total: ""
                    ,
                  })
                }
              />
            </Grid> */}
            <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }} mt={2} ml={2}>
              Payment Terms
            </Typography>

            {paymentTerms.map((row, index) => (
              <Grid container spacing={2} key={row.id} alignItems="center" mt={1} ml={1}>
                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Percentage"
                    {...register(`paymentTerms.${index}.percentage`, {
                      onChange: (event) => handlePercentageChange(index, event)
                    })}
                    id={`paymentTerms-percentage-${index}`}


                    control={control}
                    type={TextType.Number} // numeric input if needed
                  />
                </Grid>

                <Grid item xs={6} sm={6}>
                  <WSTextField
                    label="Description"
                    {...register(`paymentTerms.${index}.description`)}
                    id={`paymentTerms-description-${index}`}
                    control={control}
                  />
                </Grid>

                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => paymentRemove(index)}
                    sx={{ color: "red", cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
            ))}
            <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addExtraChargeButton"
                label="+ Add"
                size="small"
                sx={{ fontSize: "0.875rem" }}
                onClick={() =>
                  paymentAppend({
                    percentage: 0,
                    description: ""
                  })
                }
              />
            </Grid>
            {/* Terms & Conditions */}
            <Grid item xs={12} sm={12}>
              <WSTextAreaField
                id="termsandcondition"
                label="Terms and Conditions"
                bulletType="bullet"
                {...register("termsAndConditions")}
                required={true}
                control={control}
                rows={3}
              />
            </Grid>
            {/* paymentTerms */}

            {/* <Grid item xs={12} sm={12}>
              <WSTextAreaField
                id="paymentTerms"
                label="Payment Terms"
                {...register("paymentTerms")}
                control={control}
                rows={3}
              />
            </Grid> */}

            <Grid container spacing={2} mt={1} sx={{ padding: 2 }}>

              <Grid item xs={12}>
                <Typography sx={{ fontSize: '.75rem' }} fontWeight={"bold"}>Advanced Amount</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSelectField
                  label={"Payment Method"}
                  id="paymentMethod"
                  name="paymentMethod"
                  options={clientConfig.paymentMethodConfig.staticOptionData}
                  control={control}
                  disabled={disable}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Amount"}
                  id="amountReceived"
                  name="amountReceived"
                  control={control}
                  rules={{ required: false }}
                  type={TextType.Currency}
                  disabled={disable}
                  currency={CurrencyType.Rupee}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <WSTextField
                  label={"Transaction Reference"}
                  id="transactionReference"
                  name="transactionReference"
                  control={control}
                  disabled={disable}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <WSTextField
                  label={"Invoice Number"}
                  id="invoiceNumber"
                  name="invoiceNumber"
                  disabled={disable}
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item xs={12}>
                <WSTextAreaField
                  label="Add Note"
                  id="notes"
                  setValue={setValue}
                  control={control}
                  disabled={disable}
                  rules={{ required: false }}
                  name="notes"
                  rows={2}
                />

              </Grid>
              <Grid item xs={12} sm={12}>
                <Divider />
              </Grid>


            </Grid>
          </Grid>

        </Card>
      </form>
    </Grid>
  );
});
